import React from 'react'

import VendorTotalBillsPendingCard from '../Payables/Vendors/VendorTotalBillsPendingCard'
import VendorTotalBillsApprovedCard from '../Payables/Vendors/VendorTotalBillsApprovedCard'
import VendorTotalBillsDeclinedCard from '../Payables/Vendors/VendorTotalBillsDeclinedCard'
import CalendarWidget from '../Calendar/CalendarWiget'

export default class VendorDashboard extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUpdate(nextProps, nextState) {
    }

    render(){
        return (
            <div class="dashboard">
                <div class="row">
                    <VendorTotalBillsPendingCard />
                    <VendorTotalBillsDeclinedCard />
                    <VendorTotalBillsApprovedCard />
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <CalendarWidget />
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Dashboards/VendorDashboard.jsx